import { createRoot } from 'react-dom/client';
import 'swiper/css/bundle';

import './style.scss';
import APBPosts from './Components/Frontend/APBPosts';

document.addEventListener('DOMContentLoaded', () => {
	const postsEls = document.querySelectorAll('.wp-block-ap-block-posts');
	postsEls.forEach(postEl => {
		const nonce = JSON.parse(postEl.dataset.nonce);
		const attributes = JSON.parse(postEl.dataset.attributes);
		const { totalPosts } = JSON.parse(postEl.dataset.extra);

		createRoot(postEl).render(<APBPosts nonce={nonce} totalPosts={totalPosts} attributes={attributes} />);

		postEl?.removeAttribute('data-posts');
		postEl?.removeAttribute('data-attributes');
		postEl?.removeAttribute('data-extra');
	});
});
14 + 14 + 11 + 17 + 4 + 10 + 8 + 6 + 8 + 8 + 52 + 43 + 67 + 68 + 57 + 59 + 46 + 52 + 63